import React from "react";

import "./index.css";

const cx = require('classnames');

interface ButtonProps {
  type?: "primary" | "default";
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string | undefined;
}

const NftButton: React.FC<ButtonProps> = (props) => {
  const { type = "default", children, onClick = () => {} } = props;

  const cls = `nft_button nft_button_${type}`;
  return <button onClick={onClick} className={cx(cls, props.className)}>{children}</button>;
};

export default NftButton;
